import React from 'react'

export default function ContactWeb() {
  return (
    <div>ContactWeb</div>
  )
}
